import classNames from "classnames";
import React, { useEffect } from "react";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import TabsContext from "../tabs-context";

import { IProps } from "./tabs-button.types";
import "./tabs-button.scss";

/**
 * Button to change tab. Using the tab ID, the item with the matching the same ID will be shown.
 * @param props.children Content for the tab button.
 * @param props.tabId    Identifier to link tab buttons and their content.
 * @returns              Button to change tab.
 */
const TabsButton: React.FunctionComponent<IProps> = ({ children, showWarning, tabId }: IProps) => {
    const { activeTabId, addTab, setTab } = React.useContext(TabsContext);

    // Register the tab.
    useEffect(() => {
        addTab(tabId);
    }, [addTab, tabId]);

    return (
        <div
            className={classNames("tabs__button", { "tabs__button--active": activeTabId === tabId })}
            role="button"
            onClick={() => {
                setTab(tabId);
            }}
        >
            <div>{children}</div>
            {showWarning && (
                <div className="tabs__button__warning">
                    <FontAwesomeIcon title="tabs button warning" icon={faExclamationTriangle} />
                </div>
            )}
        </div>
    );
};

TabsButton.defaultProps = { showWarning: false };

export default TabsButton;
